import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Network } from '@capacitor/network';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if ('serviceWorker' in navigator && environment.production) {
      navigator.serviceWorker.register('ngsw-worker.js');
    }
  })
  .catch((err) => {
    //console.log(err)
  });

async function initNetworkEvents() {
  const status = await Network.getStatus();
  handleNetworkChange(status.connected);

  Network.addListener('networkStatusChange', (status) => {
    handleNetworkChange(status.connected);
  });
}

function handleNetworkChange(isConnected: boolean) {
  const offlineBanner = document.getElementById('offline-banner');
  if (offlineBanner) {
    offlineBanner.style.display = isConnected ? 'none' : 'block';
  }

  if (!isConnected) {
    console.warn('🚫 You are offline');
    // Optional: Show a toast or notification here
  } else {
    console.info('✅ Back online');
  }
}

initNetworkEvents();

defineCustomElements(window);
